export const REDUCER_NAME="businessCategorySlice";

export interface iBusinessCategoryRespone {
    id: string;
    name:string;
    created_at: string;
    updated_at: string; 

  }

  
  export interface iBusinessCategoryState {
      businessCategoryList:[]
      isLoading: boolean;
      errorMessage: string | null;
  }

  export interface iBusinessCategoryDTO{
    name?:string
  }